import React, { useState, useEffect } from 'react';
import { StandardURL } from '../services/constants';

// ─── Inline Styles ──────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600&display=swap');

  .admin-wrapper {
    background: #0a0a0a;
    color: #f0f0f0;
    min-height: 100vh;
    padding: 3rem 2rem;
    font-family: 'DM Sans', sans-serif;
  }

  .admin-container {
    max-width: 1400px;
    margin: 0 auto;
  }

  .admin-card {
    background: #111111;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    padding: 2.5rem;
    margin-bottom: 2rem;
  }

  .admin-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2.5rem;
    letter-spacing: 0.06em;
    margin-bottom: 1.5rem;
  }

  .admin-title span {
    color: #e8ff3c;
  }

  /* Toast Notification */
  .toast-container {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .toast {
    min-width: 250px;
    padding: 1rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    font-family: 'DM Sans', sans-serif;
    color: #fff;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    animation: slideIn 0.3s ease forwards, fadeOut 0.3s ease 3s forwards;
  }

  .toast.success {
    background: #16a34a;
    border-left: 4px solid #e8ff3c;
  }

  .toast.error {
    background: #dc2626;
    border-left: 4px solid #f87171;
  }

  .toast.info {
    background: #3b82f6;
    border-left: 4px solid #93c5fd;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      visibility: hidden;
    }
  }

  /* Form Styles */
  .admin-form label {
    display: block;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #666;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .admin-form input,
  .admin-form select {
    width: 100%;
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    color: #f0f0f0;
    border-radius: 6px;
    padding: 0.75rem 1rem;
    font-size: 0.9rem;
    font-family: 'DM Sans', sans-serif;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;
  }

  .admin-form input[type="file"] {
    padding: 0.6rem 1rem;
  }

  .admin-form input:focus,
  .admin-form select:focus {
    border-color: #e8ff3c;
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .form-row-3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .btn-submit {
    background: #e8ff3c;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 0.85rem 2rem;
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: opacity 0.2s;
    width: 100%;
  }

  .btn-submit:hover:not(:disabled) {
    opacity: 0.85;
  }

  .btn-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Table Styles */
  .admin-table-wrap {
    overflow-x: auto;
  }

  .admin-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    white-space: nowrap;
  }

  .admin-table th {
    padding: 1rem;
    border-bottom: 1px solid #2a2a2a;
    color: #666;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .admin-table td {
    padding: 1rem;
    border-bottom: 1px solid #1a1a1a;
    vertical-align: middle;
    font-size: 0.9rem;
  }

  .admin-table tr:hover {
    background: rgba(255, 255, 255, 0.02);
  }

  .accent-text {
    color: #e8ff3c;
    font-family: monospace;
  }

  .yt-link {
    color: #e8ff3c;
    text-decoration: none;
  }

  .yt-link:hover {
    text-decoration: underline;
  }

  .resource-text {
    color: #aaa;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .resource-text a {
    color: #e8ff3c;
    text-decoration: none;
  }

  .resource-text a:hover {
    text-decoration: underline;
  }

  .status-badge {
    padding: 0.3rem 0.6rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .status-active {
    background: rgba(232, 255, 60, 0.1);
    color: #e8ff3c;
  }

  .status-inactive {
    background: rgba(255, 69, 69, 0.1);
    color: #ff4545;
  }

  .action-btns {
    display: flex;
    gap: 0.5rem;
  }

  .btn-action {
    background: transparent;
    border: 1px solid;
    padding: 0.4rem 0.8rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.75rem;
    font-weight: 600;
    transition: all 0.2s;
  }

  .btn-edit {
    color: #4da6ff;
    border-color: rgba(77, 166, 255, 0.3);
  }

  .btn-edit:hover {
    background: rgba(77, 166, 255, 0.1);
    border-color: #4da6ff;
  }

  .btn-delete {
    color: #ff4545;
    border-color: rgba(255, 69, 69, 0.3);
  }

  .btn-delete:hover {
    background: rgba(255, 69, 69, 0.1);
    border-color: #ff4545;
  }

  audio {
    height: 32px;
    max-width: 200px;
    border-radius: 4px;
  }

  .cover-thumb {
    width: 45px;
    height: 45px;
    border-radius: 4px;
    object-fit: cover;
    border: 1px solid #2a2a2a;
  }

  /* Modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
  }

  .modal-content {
    background: #111;
    border: 1px solid #2a2a2a;
    border-radius: 8px;
    width: 100%;
    max-width: 700px;
    padding: 2.5rem;
    box-shadow: 0 10px 40px rgba(0,0,0,0.5);
    max-height: 90vh;
    overflow-y: auto;
  }

  .btn-cancel {
    background: transparent;
    color: #f0f0f0;
    border: 1px solid #666;
    border-radius: 4px;
    padding: 0.85rem 2rem;
    cursor: pointer;
    width: 100%;
    margin-top: 1rem;
  }

  .btn-cancel:hover {
    background: rgba(255,255,255,0.05);
  }

  @media (max-width: 768px) {
    .form-row,
    .form-row-3 {
      grid-template-columns: 1fr;
      gap: 1rem;
    }

    .admin-wrapper {
      padding: 1.5rem 1rem;
    }

    .admin-card {
      padding: 1.5rem;
    }
  }
`;

const MusicManager = () => {
  const token = localStorage.getItem("token");

  // ============================================================
  // STATE
  // ============================================================

  const [musicList, setMusicList] = useState([]);
  const [categories, setCategories] = useState([]);

  // Toast
  const [toasts, setToasts] = useState([]);

  // ============================================================
  // ADD FORM STATE
  // ============================================================

  const [name, setName] = useState('');
  const [photoFile, setPhotoFile] = useState(null);
  const [musicFile, setMusicFile] = useState(null);

  // These are now TEXT values, not files
  const [wav, setWav] = useState('');
  const [stems, setStems] = useState('');
  const [drivemail, setDrivemail] = useState('');

  const [price, setPrice] = useState('');
  const [pricePremium, setPricePremium] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [youtube, setYoutube] = useState('');

  // ============================================================
  // EDIT FORM STATE
  // ============================================================

  const [editingMusic, setEditingMusic] = useState(null);

  const [editFormData, setEditFormData] = useState({
    name: '',
    price: '',
    pricepremium: '',
    youtube: '',
    status: 'active',
    wav: '',
    stems: '',
    drivemail: '',
    photoFile: null
  });

  const [loading, setLoading] = useState(false);

  // ============================================================
  // INITIAL LOAD
  // ============================================================

  useEffect(() => {
    fetchCategories();
    fetchMusicList();
  }, []);

  // ============================================================
  // TOAST
  // ============================================================

  const triggerToast = (message, type = 'success') => {
    const id = Date.now();

    setToasts((prev) => [
      ...prev,
      {
        id,
        message,
        type
      }
    ]);

    setTimeout(() => {
      setToasts((prev) =>
        prev.filter((t) => t.id !== id)
      );
    }, 3300);
  };

  // ============================================================
  // FETCH CATEGORIES
  // ============================================================

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${StandardURL}/iMusic/user/category/listadmin`
      );

      const data = await response.json();

      setCategories(
        Array.isArray(data?.response)
          ? data.response
          : []
      );

    } catch (error) {
      console.error(error);
    }
  };

  // ============================================================
  // FETCH MUSIC
  // ============================================================

  const fetchMusicList = async () => {
    try {
      const response = await fetch(
        `${StandardURL}/iMusic/user/music/listadmin`
      );

      const data = await response.json();

      setMusicList(
        Array.isArray(data?.response)
          ? data.response
          : []
      );

    } catch (error) {
      console.error(error);
    }
  };

  // ============================================================
  // DROPBOX UPLOAD
  // ONLY USED FOR COVER + MP3
  // ============================================================

  const uploadFileToDropbox = async (file, folder) => {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('folder', folder);

    const response = await fetch(
      `${StandardURL}/api/upload`,
      {
        method: 'POST',
        body: formData
      }
    );

    if (!response.ok) {
      throw new Error(
        `Failed to upload ${file.name}`
      );
    }

    const data = await response.json();

    return data.response.url;
  };

  // ============================================================
  // ADD MUSIC
  // ============================================================

  const handleAddMusic = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      // --------------------------------------------------------
      // Upload Cover
      // --------------------------------------------------------

      triggerToast(
        "Uploading cover photo...",
        "info"
      );

      const photo_url =
        await uploadFileToDropbox(
          photoFile,
          "photos"
        );

      // --------------------------------------------------------
      // Upload MP3
      // --------------------------------------------------------

      triggerToast(
        "Uploading MP3...",
        "info"
      );

      const music_url =
        await uploadFileToDropbox(
          musicFile,
          "music"
        );

      // --------------------------------------------------------
      // Save
      // --------------------------------------------------------

      triggerToast(
        "Saving music...",
        "info"
      );

      const payload = {
        name,
        price,
        pricepremium: pricePremium,
        category: selectedCategory,
        youtube,

        // Dropbox URLs
        photo_url,
        music_url,

        // Plain text / VARCHAR values
        wav,
        stems,
        drivemail
      };

      const response = await fetch(
        `${StandardURL}/iMusic/user/music/add`,
        {
          method: "POST",

          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },

          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {

        const errorData =
          await response
            .json()
            .catch(() => ({}));

        throw new Error(
          errorData.error ||
          errorData.message ||
          "Failed to save music."
        );
      }

      // --------------------------------------------------------
      // Success
      // --------------------------------------------------------

      triggerToast(
        "Music added successfully!",
        "success"
      );

      // Reset form

      setName("");
      setPhotoFile(null);
      setMusicFile(null);

      setWav("");
      setStems("");
      setDrivemail("");

      setPrice("");
      setPricePremium("");
      setSelectedCategory("");
      setYoutube("");

      document
        .querySelectorAll(
          '.admin-form input[type="file"]'
        )
        .forEach(input => {
          input.value = "";
        });

      fetchMusicList();

    } catch (err) {

      console.error(err);

      triggerToast(
        err.message || "Upload failed.",
        "error"
      );

    } finally {

      setLoading(false);

    }
  };

  // ============================================================
  // DELETE MUSIC
  // ============================================================

  const handleDelete = async (id) => {

    if (
      !window.confirm(
        'Are you sure you want to delete this track? This will also remove files from Dropbox.'
      )
    ) {
      return;
    }

    try {

      const response = await fetch(
        `${StandardURL}/iMusic/user/music/delete/${id}`,
        {
          method: 'DELETE',

          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.ok) {

        triggerToast(
          'Music deleted successfully.',
          'success'
        );

        fetchMusicList();

      } else {

        const errorData =
          await response
            .json()
            .catch(() => ({}));

        triggerToast(
          errorData.error ||
          errorData.message ||
          'Failed to delete music.',
          'error'
        );
      }

    } catch (error) {

      console.error(error);

      triggerToast(
        'An error occurred while deleting.',
        'error'
      );
    }
  };

  // ============================================================
  // OPEN EDIT MODAL
  // ============================================================

  const openEditModal = (music) => {

    setEditingMusic(music);

    setEditFormData({

      name: music.name || '',

      price: music.price || '',

      pricepremium:
        music.pricepremium || '',

      youtube:
        music.youtube || '',

      status:
        music.status || 'active',

      wav:
        music.wav || '',

      stems:
        music.stems || '',

      drivemail:
        music.drivemail || '',

      photoFile: null
    });
  };

  // ============================================================
  // EDIT FIELD CHANGE
  // ============================================================

  const handleUpdateChange = (e) => {

    const {
      name,
      value,
      files
    } = e.target;

    if (name === 'photoFile') {

      setEditFormData(prev => ({
        ...prev,
        photoFile:
          files?.[0] || null
      }));

    } else {

      setEditFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // ============================================================
  // UPDATE MUSIC
  // ============================================================

  const handleUpdateSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      let updatedPhotoUrl = undefined;

      // --------------------------------------------------------
      // Upload replacement cover if selected
      // --------------------------------------------------------

      if (editFormData.photoFile) {

        triggerToast(
          'Uploading new cover photo...',
          'info'
        );

        updatedPhotoUrl =
          await uploadFileToDropbox(
            editFormData.photoFile,
            'photos'
          );
      }

      // --------------------------------------------------------
      // Prepare payload
      // --------------------------------------------------------

      const payload = {

        name:
          editFormData.name,

        price:
          editFormData.price,

        pricepremium:
          editFormData.pricepremium,

        youtube:
          editFormData.youtube,

        status:
          editFormData.status,

        // Text fields
        wav:
          editFormData.wav,

        stems:
          editFormData.stems,

        // IMPORTANT:
        // Exact database column name
        drivemail:
          editFormData.drivemail
      };

      // --------------------------------------------------------
      // Replacement photo
      // --------------------------------------------------------

      if (updatedPhotoUrl) {
        payload.photo_url =
          updatedPhotoUrl;
      }

      // --------------------------------------------------------
      // Send update
      // --------------------------------------------------------

      const response = await fetch(
        `${StandardURL}/iMusic/user/music/update/${editingMusic.id}`,
        {
          method: 'POST',

          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },

          body: JSON.stringify(payload)
        }
      );

      if (response.ok) {

        triggerToast(
          'Music updated successfully! ✅',
          'success'
        );

        setEditingMusic(null);

        fetchMusicList();

      } else {

        const errorData =
          await response
            .json()
            .catch(() => ({}));

        triggerToast(
          errorData.error ||
          errorData.message ||
          'Failed to update music.',
          'error'
        );
      }

    } catch (error) {

      console.error(error);

      triggerToast(
        error.message ||
        'An error occurred during update.',
        'error'
      );

    } finally {

      setLoading(false);

    }
  };

  // ============================================================
  // RESOURCE URL
  // ============================================================

  const getResourceSrc = (dbUrl) => {

    if (!dbUrl) {
      return '';
    }

    return dbUrl.startsWith('http')
      ? dbUrl
      : `${StandardURL}${dbUrl}`;
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div className="admin-wrapper">

      <style>
        {styles}
      </style>

      {/* ======================================================
          TOAST
      ====================================================== */}

      <div className="toast-container">

        {toasts.map((toast) => (

          <div
            key={toast.id}
            className={`toast ${toast.type}`}
          >
            {toast.message}
          </div>

        ))}

      </div>

      <div className="admin-container">

        {/* ====================================================
            ADD MUSIC
        ==================================================== */}

        <div className="admin-card">

          <h2 className="admin-title">
            ADD <span>MUSIC</span>
          </h2>

          <form
            onSubmit={handleAddMusic}
            className="admin-form"
          >

            {/* ------------------------------------------------
                BASIC INFORMATION
            ------------------------------------------------ */}

            <div className="form-row-3">

              <div>

                <label>
                  Track Name
                </label>

                <input
                  type="text"
                  placeholder="e.g. Summer Vibes Beat"
                  value={name}
                  onChange={(e) =>
                    setName(e.target.value)
                  }
                  required
                />

              </div>

              <div>

                <label>
                  Genre / Category
                </label>

                <select
                  value={selectedCategory}
                  onChange={(e) =>
                    setSelectedCategory(
                      e.target.value
                    )
                  }
                  required
                >

                  <option
                    value=""
                    disabled
                  >
                    Select category...
                  </option>

                  {categories.map((cat) => (

                    <option
                      key={
                        cat.id ||
                        cat.category
                      }
                      value={cat.category}
                    >
                      {cat.category}
                    </option>

                  ))}

                </select>

              </div>

              <div>

                <label>
                  YouTube Link (Optional)
                </label>

                <input
                  type="url"
                  placeholder="https://youtube.com/watch?v=..."
                  value={youtube}
                  onChange={(e) =>
                    setYoutube(
                      e.target.value
                    )
                  }
                />

              </div>

            </div>

            {/* ------------------------------------------------
                PRICING + COVER
            ------------------------------------------------ */}

            <div className="form-row-3">

              <div>

                <label>
                  Standard Price (USD)
                </label>

                <input
                  type="number"
                  step="0.01"
                  value={price}
                  onChange={(e) =>
                    setPrice(
                      e.target.value
                    )
                  }
                  required
                />

              </div>

              <div>

                <label>
                  Premium Price (USD)
                </label>

                <input
                  type="number"
                  step="0.01"
                  value={pricePremium}
                  onChange={(e) =>
                    setPricePremium(
                      e.target.value
                    )
                  }
                  required
                />

              </div>

              <div>

                <label>
                  Cover Photo (JPG/PNG)
                </label>

                <input
                  type="file"
                  accept="image/jpeg, image/png, image/webp"
                  onChange={(e) =>
                    setPhotoFile(
                      e.target.files?.[0] ||
                      null
                    )
                  }
                  required
                />

              </div>

            </div>

            {/* ------------------------------------------------
                MP3 + WAV + STEMS
            ------------------------------------------------ */}

            <div className="form-row-3">

              <div>

                <label>
                  Music File (MP3)
                </label>

                <input
                  type="file"
                  accept=".mp3,audio/mpeg"
                  onChange={(e) =>
                    setMusicFile(
                      e.target.files?.[0] ||
                      null
                    )
                  }
                  required
                />

              </div>

              <div>

                <label>
                  Uncompressed (WAV)
                </label>

                <input
                  type="text"
                  placeholder="Enter WAV link or reference"
                  value={wav}
                  onChange={(e) =>
                    setWav(
                      e.target.value
                    )
                  }
                />

              </div>

              <div>

                <label>
                  Track Stems (ZIP/RAR)
                </label>

                <input
                  type="text"
                  placeholder="Enter stems link or reference"
                  value={stems}
                  onChange={(e) =>
                    setStems(
                      e.target.value
                    )
                  }
                />

              </div>

            </div>

            {/* ------------------------------------------------
                DRIVE EMAIL
            ------------------------------------------------ */}

            <div className="form-row">

              <div>

                <label>
                  Drive Email
                </label>

                <input
                  type="email"
                  placeholder="Enter Google Drive email"
                  value={drivemail}
                  onChange={(e) =>
                    setDrivemail(
                      e.target.value
                    )
                  }
                />

              </div>

            </div>

            {/* ------------------------------------------------
                SUBMIT
            ------------------------------------------------ */}

            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
            >
              {loading
                ? 'Processing Uploads...'
                : 'Upload Beat'}
            </button>

          </form>

        </div>

        {/* ====================================================
            MUSIC LIBRARY
        ==================================================== */}

        <div className="admin-card">

          <h2 className="admin-title">
            MUSIC <span>LIBRARY</span>
          </h2>

          {musicList.length === 0 ? (

            <p style={{ color: '#666' }}>
              No beats found in the database.
            </p>

          ) : (

            <div className="admin-table-wrap">

              <table className="admin-table">

                <thead>

                  <tr>

                    <th>ID</th>
                    <th>Cover</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Status</th>
                    <th>Preview</th>
                    <th>YouTube</th>
                    <th>WAV</th>
                    <th>Stems</th>
                    <th>Drive Email</th>
                    <th>Standard</th>
                    <th>Premium</th>
                    <th>Actions</th>

                  </tr>

                </thead>

                <tbody>

                  {musicList.map((music) => (

                    <tr key={music.id}>

                      {/* ID */}

                      <td className="accent-text">
                        #{music.id}
                      </td>

                      {/* COVER */}

                      <td>

                        {music.photo ? (

                          <img
                            src={getResourceSrc(
                              music.photo
                            )}
                            alt="cover"
                            className="cover-thumb"
                          />

                        ) : (

                          <div
                            className="cover-thumb"
                            style={{
                              background: '#222',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '0.6rem',
                              color: '#666'
                            }}
                          >
                            No Pic
                          </div>

                        )}

                      </td>

                      {/* NAME */}

                      <td
                        style={{
                          fontWeight: '600'
                        }}
                      >
                        {music.name ||
                          'Untitled'}
                      </td>

                      {/* CATEGORY */}

                      <td>
                        {music.category}
                      </td>

                      {/* STATUS */}

                      <td>

                        <span
                          className={`status-badge ${
                            music.status ===
                            'active'
                              ? 'status-active'
                              : 'status-inactive'
                          }`}
                        >
                          {music.status}
                        </span>

                      </td>

                      {/* MP3 */}

                      <td>

                        {music.music ? (

                          <audio
                            controls
                            controlsList="nodownload"
                            preload="none"
                            src={getResourceSrc(
                              music.music
                            )}
                          />

                        ) : (

                          <span
                            style={{
                              color: '#666',
                              fontSize: '0.8rem'
                            }}
                          >
                            No Audio
                          </span>

                        )}

                      </td>

                      {/* YOUTUBE */}

                      <td>

                        {music.youtube ? (

                          <a
                            href={music.youtube}
                            target="_blank"
                            rel="noreferrer"
                            className="yt-link"
                          >
                            Watch
                          </a>

                        ) : (

                          <span
                            style={{
                              color: '#555'
                            }}
                          >
                            —
                          </span>

                        )}

                      </td>

                      {/* WAV */}

                      <td>

                        {music.wav ? (

                          music.wav.startsWith(
                            'http'
                          ) ? (

                            <div className="resource-text">

                              <a
                                href={music.wav}
                                target="_blank"
                                rel="noreferrer"
                              >
                                View WAV
                              </a>

                            </div>

                          ) : (

                            <div className="resource-text">
                              {music.wav}
                            </div>

                          )

                        ) : (

                          <span
                            style={{
                              color: '#555'
                            }}
                          >
                            —
                          </span>

                        )}

                      </td>

                      {/* STEMS */}

                      <td>

                        {music.stems ? (

                          music.stems.startsWith(
                            'http'
                          ) ? (

                            <div className="resource-text">

                              <a
                                href={music.stems}
                                target="_blank"
                                rel="noreferrer"
                              >
                                View Stems
                              </a>

                            </div>

                          ) : (

                            <div className="resource-text">
                              {music.stems}
                            </div>

                          )

                        ) : (

                          <span
                            style={{
                              color: '#555'
                            }}
                          >
                            —
                          </span>

                        )}

                      </td>

                      {/* DRIVE EMAIL */}

                      <td>

                        {music.drivemail ? (

                          <div className="resource-text">
                            {music.drivemail}
                          </div>

                        ) : (

                          <span
                            style={{
                              color: '#555'
                            }}
                          >
                            —
                          </span>

                        )}

                      </td>

                      {/* STANDARD */}

                      <td>
                        $
                        {Number(
                          music.price
                        ).toFixed(2)}
                      </td>

                      {/* PREMIUM */}

                      <td>
                        $
                        {Number(
                          music.pricepremium
                        ).toFixed(2)}
                      </td>

                      {/* ACTIONS */}

                      <td>

                        <div className="action-btns">

                          <button
                            className="btn-action btn-edit"
                            onClick={() =>
                              openEditModal(
                                music
                              )
                            }
                          >
                            ✎ Edit
                          </button>

                          <button
                            className="btn-action btn-delete"
                            onClick={() =>
                              handleDelete(
                                music.id
                              )
                            }
                          >
                            ✕ Delete
                          </button>

                        </div>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

      {/* ======================================================
          EDIT MODAL
      ====================================================== */}

      {editingMusic && (

        <div className="modal-overlay">

          <div className="modal-content admin-form">

            <h2
              className="admin-title"
              style={{
                fontSize: '2rem',
                marginTop: 0
              }}
            >
              EDIT{' '}
              <span>
                {editingMusic.name ||
                  'TRACK'}
              </span>
            </h2>

            <form
              onSubmit={
                handleUpdateSubmit
              }
            >

              {/* ------------------------------------------------
                  NAME + COVER
              ------------------------------------------------ */}

              <div className="form-row">

                <div>

                  <label>
                    Track Name
                  </label>

                  <input
                    type="text"
                    name="name"
                    value={
                      editFormData.name
                    }
                    onChange={
                      handleUpdateChange
                    }
                    required
                  />

                </div>

                <div>

                  <label>
                    Update Cover Photo
                    (Optional)
                  </label>

                  <input
                    type="file"
                    name="photoFile"
                    accept="image/jpeg, image/png, image/webp"
                    onChange={
                      handleUpdateChange
                    }
                  />

                </div>

              </div>

              {/* ------------------------------------------------
                  PRICES
              ------------------------------------------------ */}

              <div className="form-row">

                <div>

                  <label>
                    Standard Price
                  </label>

                  <input
                    type="number"
                    name="price"
                    step="0.01"
                    value={
                      editFormData.price
                    }
                    onChange={
                      handleUpdateChange
                    }
                    required
                  />

                </div>

                <div>

                  <label>
                    Premium Price
                  </label>

                  <input
                    type="number"
                    name="pricepremium"
                    step="0.01"
                    value={
                      editFormData.pricepremium
                    }
                    onChange={
                      handleUpdateChange
                    }
                    required
                  />

                </div>

              </div>

              {/* ------------------------------------------------
                  YOUTUBE + STATUS
              ------------------------------------------------ */}

              <div className="form-row">

                <div>

                  <label>
                    YouTube Link
                  </label>

                  <input
                    type="url"
                    name="youtube"
                    value={
                      editFormData.youtube
                    }
                    onChange={
                      handleUpdateChange
                    }
                  />

                </div>

                <div>

                  <label>
                    Status
                  </label>

                  <select
                    name="status"
                    value={
                      editFormData.status
                    }
                    onChange={
                      handleUpdateChange
                    }
                  >

                    <option value="active">
                      Active
                    </option>

                    <option value="inactive">
                      Inactive
                    </option>

                  </select>

                </div>

              </div>

              {/* ------------------------------------------------
                  WAV + STEMS
              ------------------------------------------------ */}

              <div className="form-row">

                <div>

                  <label>
                    Uncompressed (WAV)
                  </label>

                  <input
                    type="text"
                    name="wav"
                    placeholder="Enter WAV link or reference"
                    value={
                      editFormData.wav
                    }
                    onChange={
                      handleUpdateChange
                    }
                  />

                </div>

                <div>

                  <label>
                    Track Stems (ZIP/RAR)
                  </label>

                  <input
                    type="text"
                    name="stems"
                    placeholder="Enter stems link or reference"
                    value={
                      editFormData.stems
                    }
                    onChange={
                      handleUpdateChange
                    }
                  />

                </div>

              </div>

              {/* ------------------------------------------------
                  DRIVE EMAIL
              ------------------------------------------------ */}

              <div className="form-row">

                <div>

                  <label>
                    Drive Email
                  </label>

                  <input
                    type="email"
                    name="drivemail"
                    placeholder="Enter Google Drive email"
                    value={
                      editFormData.drivemail
                    }
                    onChange={
                      handleUpdateChange
                    }
                  />

                </div>

              </div>

              {/* ------------------------------------------------
                  BUTTONS
              ------------------------------------------------ */}

              <button
                type="submit"
                className="btn-submit"
                disabled={loading}
              >
                {loading
                  ? 'Saving Changes...'
                  : 'Save Updates'}
              </button>

              <button
                type="button"
                className="btn-cancel"
                onClick={() =>
                  setEditingMusic(null)
                }
              >
                Cancel
              </button>

            </form>

          </div>

        </div>

      )}

    </div>
  );
};

export default MusicManager;